import { Test } from './Test';
import { Source } from './Source';
export class TestRequest {
  Id: string ="";
  LabNumber: string = "";
  HospitalNo: string = "";
  Reference: string = "";
  Sex: string = "";
  RequestDate: Date=new Date();
  Title: string = "";
  Dob: Date =new Date();
  AttendingDr: string = "";
  AccountTo: string = "";
  IsGrey: boolean = false;
  IsFasting: boolean = false;
  NeedsKit: boolean = false;
  NeedsVenous: boolean = false;
  ForeName: string = "";
  Surname: string = "";
  Email: string = "";
  Phone: string = "";
  SampleDate: Date=new Date();
  Address1: string = "";
  Address2: string = "";
  Address3: string = "";
  PostCode: string = "";
  InsuranceNum: string = "";
  InsuranceCo: string = "";
  ClinDets: string = "";
  Tests: Test[] = [];
  Source: Source = new Source();
  Clinician: string=""
}
